import osmtogeojson from "osmtogeojson";

interface PostalCodeCountry {
  postalCode: string;
  countryCode: string;
}

export default () => {
  const getPostalCodeBoundaries = async (postalCodesWithCountryCodes: PostalCodeCountry[]) => {
    const endpoint = "https://overpass-api.de/api/interpreter";

    // Group postal codes by country to minimize the number of area lookups
    const postalCodesByCountry = postalCodesWithCountryCodes.reduce((acc, { postalCode, countryCode }) => {
      if (!acc[countryCode]) acc[countryCode] = [];
      acc[countryCode].push(postalCode);
      return acc;
    }, {} as Record<string, string[]>);

    const queries = Object.entries(postalCodesByCountry).map(([countryCode, postalCodes]) => {
      // Create a regular expression to match postal codes in the list
      const postalCodeRegex = postalCodes.map(code => `^${code}$`).join("|");

      return `
        area["ISO3166-1"="${countryCode}"][admin_level=2]->.searchArea;
        (
          relation["boundary"="postal_code"]["postal_code"~"${postalCodeRegex}"](area.searchArea);
          way["boundary"="postal_code"]["postal_code"~"${postalCodeRegex}"](area.searchArea);
          node["boundary"="postal_code"]["postal_code"~"${postalCodeRegex}"](area.searchArea);
        );
      `;
    });

    const fullQuery = `
      [out:json][timeout:600];
      (
        ${queries.join("\n")}
      );
      out body;
      >;
      out skel qt;
    `;

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: fullQuery,
      });

      if (!response.ok) {
        throw new Error(`Error querying Overpass API: ${response.statusText}`);
      }

      const data = await response.json();
      const geojson = osmtogeojson(data);

      if (geojson && geojson.features) {
        const validFeatures = geojson.features.filter(
          feature => feature && feature.geometry && feature.properties
        );
        // console.log(`Found ${validFeatures.length} valid features`);
        return {
          type: "FeatureCollection",
          features: validFeatures,
        };
      } else {
        console.warn("No valid features found");
        return null;
      }
    } catch (error) {
      console.error("Error fetching postal code boundaries:", error);
      return null;
    }
  };

  return { getPostalCodeBoundaries };
};
